import { useState } from "react";
import { IoChatboxEllipsesOutline } from "react-icons/io5";
import DescriptionList from "./../../../../../components/common/DescriptionList";
import Modal from "./../../../../../components/common/Modal";
import ContactForm from "./ContactForm";

const ContactInformation = ({ data, isLoading, onRefresh }) => {
  const [isFormLoading, setIsFormLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);

  const email = data.email ?? "-";
  const phone_number = data.phone_number ?? "-";

  const handleSuccess = () => {
    setShowForm(false);
    onRefresh();
  };

  return (
    <div className="p-5">
      <div className="mt-0">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <IoChatboxEllipsesOutline className="mr-3 text-3xl text-gray-300" />
            <div>
              <p className="text-gray-500">Contact Information</p>
              <span className="text-xs text-gray-400">Contact Details</span>
            </div>
          </div>
          <button
            className="text-blue-500 text-sm"
            onClick={() => setShowForm(true)}
          >
            Edit
          </button>
        </div>
      </div>
      <div className="px-12 py-5 mt-5 space-y-7">
        <div className="grid grid-cols-2">
          <DescriptionList
            label="Email Address"
            className="col-span-2 sm:col-span-1"
            content={email}
            isLoading={isLoading}
          />
          <DescriptionList
            label="Phone No."
            className="col-span-2 sm:col-span-1"
            content={phone_number}
            isLoading={isLoading}
          />
        </div>
      </div>
      <Modal
        title="Contact Information"
        isOpen={showForm}
        isLoading={isFormLoading}
        onClose={() => setShowForm(false)}
        borderTop
      >
        <ContactForm
          data={data}
          isLoading={isFormLoading}
          setLoading={(value) => setIsFormLoading(value)}
          onSuccess={handleSuccess}
        />
      </Modal>
    </div>
  );
};

export default ContactInformation;
